// Typed fields are type-checked at call sites. Ad-hoc cross-level flags can be
// written as string keys (e.g. `gameFlags.lv4PowerPlantActivated = true`); promote
// a flag to a typed field here once it's read from more than one place.
export interface GameFlags {
	equationFound: boolean;
	gameWon: boolean;
	activatedPowerPlant: boolean;
	medikitHintShown: boolean;
	[key: string]: any;
}

export function createGameFlags(): GameFlags {
	return {
		equationFound: false,
		gameWon: false,
		activatedPowerPlant: false,
		medikitHintShown: false,
	};
}
